import type { TaxThresholds } from '../../types/tax';

export const TAX_THRESHOLDS_2025_26: TaxThresholds = {
  under65: 95750,      // R95,750 for under 65
  age65to74: 148217,   // R148,217 for 65-74
  age75plus: 165689    // R165,689 for 75+
};